<script>
import { mapGetters } from 'vuex'
import Badge from '@/components/molecules/Badge'
import Filters from '@/modules/mixins/filters'
import isEmpty from 'lodash.isempty'

export default {
    name: 'RestaurantsHeading',
    components: { Badge },
    mixins: [Filters],
    props: {
        restaurants: {
            type: Object,
            default: () => {},
        },
        brand: Boolean,
    },
    data() {
        return {
            left: 0,
            day: 86400000,
        }
    },
    computed: {
        ...mapGetters({
            tagsAll: 'tags/all',
            locale: 'locale',
            activeCanteen: 'active/canteen',
            smDevice: 'smDevice',
            lgDevice: 'lgDevice',
            listFiltered: 'site/listFiltered',
            orderAddress: 'order/address',
        }),
        brandName() {
            const row = ((this.restaurants && this.restaurants.items) || []).find(
                (item) => item && item.brand && item.brand.name
            )
            return row ? row.brand.name : ''
        },
        selectedFilters() {
            return this.listFiltered
                ? Object.entries(this.$route.query).reduce((p, [key, value]) => {
                      const filter = this.filters.find((filter) => filter.key === key)
                      if (value && filter) p.push(filter)
                      return p
                  }, [])
                : []
        },
        selectedTag() {
            return this.$route.query.tag_name ? this.getTag(this.$route.query.tag_name) : undefined
        },
        selectedTags: {
            get() {
                let tags = this.$route.query.tag_names
                return tags && tags.length >= 0
                    ? typeof tags === 'string'
                        ? [tags]
                        : tags.map((tag) => tag)
                    : []
            },
            set(val) {
                this.setQuery(
                    { tag_names: val && val.length ? val : undefined },
                    'restaurant-list',
                    {
                        pageLoader: false,
                    },
                    () => {
                        this.$store.dispatch('tags/fetch', this.$route)
                    }
                )
            },
        },
        search() {
            return this.$route.query.search
        },
        hasAddress() {
            return !isEmpty(this.orderAddress)
        },
        hasBanner() {
            return !!this.$route.query.bannerId
        },
    },
    methods: {
        getTag(slug) {
            return this.tagsAll?.find((filter) => filter.slug === slug) || {}
        },
        removeTags(slug) {
            this.selectedTags = this.selectedTags.filter((filter) => {
                return filter !== slug
            })
        },
        removeFilter(filter) {
            this.setQuery({ [filter.key]: undefined }, 'restaurant-list', {
                pageLoader: false,
            })
        },
        removeTag() {
            this.setQuery({ tag_name: undefined }, 'restaurant-list', {
                pageLoader: false,
            })
        },
        removeSearch() {
            this.setQuery({ search: undefined }, 'restaurant-list', {
                pageLoader: false,
            })
        },
    },
}
</script>

<template lang="pug">
.restaurants-result(v-if="listFiltered || search")
    .d-flex.align-items-baseline.flex-wrap.line-1.min-h-fix-60.mb-3
        h2.font-weight-normal.mb-0(v-if="lgDevice") {{$t('restaurant.showing_result_for')}}
        badge.mr-3.mb-3.mr-lg-0.mb-lg-0.py-lg-0(v-if="selectedTag" :type="lgDevice? 'transparent' : 'dark'" @close="removeTag" :size="smDevice ? undefined : 'h2'")
            | {{ selectedTag.name_token }}
        badge.mr-3.mb-3.mr-lg-0.mb-lg-0.py-lg-0(v-if="search" :type="lgDevice? 'transparent' : 'dark'" @close="removeSearch" :size="smDevice ? undefined : 'h2'")
            | {{ search }}
        .w-100.order-lg-1(v-if="lgDevice")
        badge.mr-3.mb-3.order-1.order-lg-2(v-for="(filter, index) in selectedFilters" :key="`selectedFilter-${index}`" type="dark" @close="removeFilter(filter)")
            | {{ filter.label}}
        badge.mr-3.mb-3.order-2.order-lg-3(v-for="(tag, index) in selectedTags" :key="`selectedTag-${index}`" type="dark" @close="removeTags(tag)")
            | {{ getTag(tag).name_token }}
        span.text-73.font-size-xs.ml-auto.order-3.order-lg-0(v-if="!brand") {{$t('restaurant.restaurants', {count: restaurants.total }, restaurants.total)}}
.list-heading(v-else-if="restaurants.length")
    h2.d-flex.align-items-baseline
        template(v-if="brand")
            template(v-if="hasAddress") {{ $t("brand.list_title_has_address") }}
            template(v-else) {{ $t("brand.list_title", { brand: brandName }) }}
        template(v-else-if="!hasBanner") {{$t('restaurant.all')}}
        span(v-if="!hasBanner && !brand").text-73.font-size-xs.ml-auto {{$t('restaurant.restaurants', {count: restaurants.total }, restaurants.total)}}
        span(v-if="brand && hasAddress").text-73.font-size-xs.ml-auto {{ $t('brand.sorted_by_distance') }}
</template>
